module.exports = __webpack_public_path__ + "img/b-green-m@3x.2d5428f9.png";